import React from 'react';
import { Table } from 'reactstrap';
import { EffectsModal } from '../EffectsModal';

export const DeathsDescriptionModal = ({ title }) => EffectsModal({
  title,
  valid: '0 to 4',
  content: (
    <div>
      <p>When a description was found in the historical literature instead of an actual number of deaths, this value was coded and listed in the Deaths column. If the actual number of deaths was listed, a descriptor was also added for search purposes.</p>
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">0</th>
            <td>None</td>
          </tr>
          <tr>
            <th scope="row">1</th>
            <td>Few (~1 to 50 deaths)</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Some (~51 to 100 deaths)</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Many (~101 to 1000 deaths)</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>Very many (over 1000 deaths)</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
});
